import Overview from '@rebuild/materials/shared/investment_activity/flowX/FlowXOverview.vue';
import FullIndex from './full.vue';
import MobOverviewIndex from '@rebuild/materials/shared/investment_activity/mobile/OverviewIndex.vue';
import MobFullIndex from './mob-full.vue';
import { withProvider } from '@rebuild/hooks/useCompWithProvider';
import { provideCurrentContext } from '@rebuild/materials/shared/investment_activity/context';

function useSelfContext() {
	provideCurrentContext({
		isSZ003010: true
	});
}

export const componentMap = {
	overview: withProvider(Overview, useSelfContext),
	full: withProvider(FullIndex, useSelfContext),
	'mob-overview': withProvider(MobOverviewIndex, useSelfContext),
	'mob-full': withProvider(MobFullIndex, useSelfContext)
};
